export default "/images/partner-3.png?8f529e95de9c1e97817464a18760713e";